import { checkDate } from "common/helpers/Date";
import { Record, List } from "immutable";
import { DateStringNumber } from "common/records";

export const priceListOverviewFromJSON = (json: Partial<IPriceListOverviewData>): PriceListOverviewRecord => {
  const record: IPriceListOverviewRecord = { ...(json as any) };

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  return new PriceListOverviewRecord(record);
};

export interface IPriceListOverviewData {
  id: number;
  name: string;

  updated_at: DateStringNumber;
}

export interface IPriceListOverviewRecord {
  id: number;
  name: string;

  updated_at: Date;
}

export const defaultPriceListOverviewProps = {
  id: 0,
  name: "",

  updated_at: new Date(),
};

export class PriceListOverviewRecord
  extends Record(defaultPriceListOverviewProps)
  implements IPriceListOverviewRecord {}
